import React from 'react';
import { FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FsProps } from 'motion-components';
import i18next from 'i18next';
import { CpWasteCategoriesTitle } from 'shared-pages/common/constants';

const gqlGetValues = gql`
  query getCpWasteCategoryValues($where: String, $offset: Int, $limit: Int) {
    getCpWasteCategories(where: $where, offset: $offset, limit: $limit, order: "name ASC") {
      data {
        id
        name
        isActive
      }
      recordCount
    }
  }
`;

function useGetValues() {
  return useLazyQuery(gqlGetValues, { fetchPolicy: 'cache-first' });
}

interface LcFsProps extends FsProps {
  size?: 'sm' | 'lg';
  sbLabel?: string;
  isMulti?: boolean;
}

/** Multi-select κατηγοριών αποβλήτων σημείου συλλογής (τιμή Formik: number[]). */
export const FieldSelectCpWasteCategory = ({
  label = i18next.t(CpWasteCategoriesTitle),
  name = 'wasteCategoryIds',
  defaultValues = {},
  sbLabel = '',
  size = 'sm',
  isMulti = true,
  ...rest
}: LcFsProps) => {
  // Μόνο ενεργές κατηγορίες στο dropdown
  const where = JSON.stringify({ isActive: 1 });
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={where}
      hook={useGetValues}
      height={size === 'lg' ? 32 : '22'}
      sortOptionValues={false}
      sbLabel={sbLabel}
      recordLabel="name"
      isMulti={isMulti}
      // Στο multi dropdown: checked/unchecked tick ανά επιλογή
      showOptionCheckbox={isMulti}
    />
  );
};
